import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFAQ } from '../actions/faqActions';
import "./faq.css";

const FAQ = () => {
  const dispatch = useDispatch();
  const faqList = useSelector((state) => state.faq.faqList);
  const [visibleFaqs, setVisibleFaqs] = useState([]);
  const observer = useRef(null);

  // Fetch FAQ data on component mount
  useEffect(() => {
    dispatch(fetchFAQ());
  }, [dispatch]);

  // Log faqList to check data
  useEffect(() => {
    console.log('FAQ List:', faqList); // Log the FAQ data
  }, [faqList]);

  // Function to load more FAQs when they come into view
  const loadMoreFAQ = (index) => {
    setVisibleFaqs((prevFaqs) => [...prevFaqs, faqList[index]]);
  };

  // Intersection observer callback to detect when an FAQ is in the viewport
  const handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Lazy load the FAQ item by adding it to the visible FAQs array
        loadMoreFAQ(entry.target.dataset.index);
        observer.current.unobserve(entry.target); // Stop observing once the FAQ item is loaded
      }
    });
  };

  // Set up intersection observer
  useEffect(() => {
    observer.current = new IntersectionObserver(handleObserver, {
      threshold: 0.1, // Trigger when 10% of the element is visible
    });

    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach((item) => {
      observer.current.observe(item);
    });

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [faqList]);

  return (
    <section id="faq" className="faq">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Frequently Asked Questions</h2>
        </div>
        {faqList && faqList.length > 0 ? (
          <ul className="faq-list accordion" data-aos="fade-up">
            {faqList.map((faq, index) => {
              // Only render FAQ items that are in the 'visibleFaqs' state
              if (visibleFaqs.includes(faq)) {
                return (
                  <li key={faq.id} className="faq-item" data-index={index}>
                    <a
                      data-bs-toggle="collapse"
                      className="collapsed"
                      data-bs-target={`#faq${index + 1}`}
                    >
                      {faq.question}{' '}
                      <i className="bx bx-chevron-down icon-show"></i>
                      <i className="bx bx-x icon-close"></i>
                    </a>
                    <div
                      id={`faq${index + 1}`}
                      className="collapse"
                      data-bs-parent=".faq-list"
                    >
                      <p>{faq.answer}</p>
                    </div>
                  </li>
                );
              }
              // Return a placeholder for FAQ items not yet loaded
              return (
                <li
                  key={faq.id}
                  className="faq-item"
                  data-index={index}
                  style={{ visibility: 'hidden' }} // Keeps space for unrendered FAQ items
                >
                  <div className="faq-placeholder"></div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="no-data">
            <p>No FAQ data available.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQ;
